/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for reading a tag.
 * @export
 * @interface TagRead
 */
export interface TagRead {
    /**
     * 
     * @type {string}
     * @memberof TagRead
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TagRead
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TagRead
     */
    id: string;
}

/**
 * Check if a given object implements the TagRead interface.
 */
export function instanceOfTagRead(value: object): value is TagRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TagReadFromJSON(json: any): TagRead {
    return TagReadFromJSONTyped(json, false);
}

export function TagReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'],
    };
}

export function TagReadToJSON(json: any): TagRead {
    return TagReadToJSONTyped(json, false);
}

export function TagReadToJSONTyped(value?: TagRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'id': value['id'],
    };
}

